import { assetTypeMap } from "src/app/shared/config/asset-type-map.config";
import { threeDimensionMapConfig } from "src/app/shared/config/three-dimension-map.config";
import { AssetType } from "src/app/shared/types/enums/map.enums";

/**
 *
 * @param assetTypes the base asset types for a layer
 * @param showAssetTypes showAssetTypes from the ngrx store used to filter base asset types
 */
export const filterAssetTypesByShowAssetTypes = (
  assetTypes: AssetType[],
  showAssetTypes?: AssetType[],
  isColumnLayer?: boolean
): AssetType[] => {
  let assetTypesFiltered: AssetType[] = [];
  let showAssetTypesInclude = showAssetTypes ? showAssetTypes : [];
  if (isColumnLayer) {
    assetTypesFiltered = assetTypes.filter(
      (assetType: AssetType) =>
        showAssetTypesInclude.includes(assetType) && !threeDimensionMapConfig.filteredAssetTypes.includes(assetType)
    );
  } else {
    assetTypesFiltered = assetTypes.filter((assetType: AssetType) => showAssetTypesInclude.includes(assetType));
  }

  return filterAssetTypesByLayerDisplayList(assetTypesFiltered);
};

export const filterAssetTypesByLayerDisplayList = (
  assetTypes: AssetType[],
  removeLocationGroup = false
): AssetType[] => {
  let assetTypesFiltered = [...assetTypes];
  if (removeLocationGroup) {
    assetTypesFiltered = assetTypesFiltered.filter((assetType: AssetType) => assetType !== AssetType.LOCATION_GROUP);
  }
  return assetTypesFiltered;
};

export const buildAssetTypesForRendering = (customViewAssetTypes: AssetType[]): AssetType[] => {
  let assetTypesForRenderering: AssetType[] = [];

  customViewAssetTypes.forEach((assetType: AssetType) => {
    assetTypesForRenderering.push(assetType);
  });

  return assetTypesForRenderering;
};
